import NotFoundIcon from "./Icons/NotFoundIcon";

const NotFound = ({ text }) => {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg shadow-sm">
      <div className="flex items-center">
        <NotFoundIcon />
        <p className="text-yellow-700 mt-1">{text}</p>
      </div>
    </div>
  );
};

export default NotFound;
